__webpack_require__.p = "/insight-board/";